<template>
  <div class="equipment-mmt">
      <div v-if="deviceList.length<=0" class="equipment-box">
        <img class="guard-img" src="@/assets/images/equipment.png" background-size="cover" />
        <p class="equipment-txt">在包装盒或设备上请找到IMEI绑定号后扫码绑定</p>
        <p @click="getMember" class="equipment-refresh">刷新</p>
      </div>
      <div v-else class="equipment-list">
        <p>提示：点击对应设备名称即可查看对应设备相关信息</p>
        <div v-for="(item,index) in deviceList" :key="index" class="list-content" @click="checkPosition(item)">
          <img class="list-img" :src="item.sex==='男'?require('@/assets/images/icon_boy.png'):require('@/assets/images/icon_girl.png')" background-size="cover" />
          <div class="list-center">
            <p>{{item.name}}</p>
            <p class="list-imei">IMEI：{{item.imei}}</p>
          </div>
          <img v-if="item.imei===imei" class="select-img" src="@/assets/images/xuanzhong.png" background-size="cover" />
        </div>
      </div>
      <div v-if="deviceList.length<=0" class="btn-box">
        <van-button round type="info" @click="addDevice">添加设备</van-button>
      </div>
      <div v-else class="btn-box">
        <van-button round type="info" @click="updateDevice">更换设备</van-button>
      </div>
  </div>
</template>
<script>
import tokenVerify from '@/utils/lib/token-verify'; //token验证
export default {
  data () {
    return {
      scanCodeMsg:'',
      deviceList:[],//设备列表
      childId:null,
    }
  },

  components: {
    
  },
  created(){
    this.getMember()
  },
  methods: {
    addDevice(){
      this.$router.push({ name: "addDevice" });
    },
    updateDevice(){
      let imei = this.deviceList[0].imei
      this.$router.push({ name: "updateDevice" , query: { data: imei } });
    },
    //获取成员列表
    getMember(){
       let data = {
        ver:1,
        method:'selectDeviceList',
      }
      this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
        if (res.code === 0) {
          // window.sessionStorage.setItem('token', res.data.token)
        } else if(res.code === 1){
          this.deviceList = res.data
          // window.sessionStorage.setItem('token', res.data[0].token)
        }
        else {
          this.$toast({
              message: res.msg,
              duration: 2000,
              icon: require('@/assets/images/safety-fence/wrong.png'),
          });
        }
      })
    },
    //根据设备进入位置页面
    checkPosition(val){
      tokenVerify(val.token)
      this.$router.push({ name: "location" });
    },
  },
}
</script>

<style scoped>
.equipment-mmt{
    font-family: PingFangSC-Regular, PingFang SC;
}
.equipment-box{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 340px;
}
.guard-img{
    width: 356px;
    height: 295px;
}
.equipment-txt{
  margin-top: 50px;
  font-size: 28px;
  font-weight: 400;
  color: #999999;
}
.equipment-refresh{
  margin-top: 35px;
  font-size: 28px;
  font-weight: 400;
  color: #0067B5;
}
.equipment-list{
 padding: 0 32px 200px;
}
.equipment-list>p{
  font-size: 24px;
  margin: 45px 0;
  font-weight: 400;
  color: #666666;
}
.equipment-list .list-content{
  display: flex;
  width: 686px;
  height: 160px;
  border-radius: 20px;
  align-items: center;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  margin-bottom: 27px;
}
.list-content .list-center{
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  margin-left: 32px;
  font-size: 32px;
  font-weight: 400;
  color: #000;
}
.list-center .list-imei{
  font-size: 28px;
  font-weight: 400;
  color: #999;
  margin-top: 5px;
}
.list-content .list-img{
  width: 78px;
  height: 78px;
  margin-left: 32px;
}
.list-content .select-img{
  width: 40px;
  height: 40px;
  margin-right: 40px;
}
.btn-box{
  z-index: 1;
  position: fixed;
  width: 100%;
  padding-bottom: 70px;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
<style>
.equipment-mmt .van-button{
  margin: 0 auto;
  border: none;
  width: 586px;
  height: 98px;
  background-color: #01ADA9;
}
</style>
